import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { GetScaAuthCodeUseCase } from './GetScaAuthCodeUseCase'

export const getScaAuthCodeUseCase = new GetScaAuthCodeUseCase({
  financialAccountRepository,
}).execute
